import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { IconInfoPublisher, IconInfoTrac } from '../../../Common/Icon';

import styles from './index.module.scss';
import { useProductsGet } from '../../../../hooks/api/products';
import { useProductContext } from '../../../../context/products';
import { getFullFileUrl } from '../../../Common/ImageUpload';

interface Product {
  id: string;
  name: string;
  logo: string;
  description?: string;
  removed?: boolean;
}

interface CardProps {
  id: string;
  logo?: string;
  name: string;
  description?: string;
}
const iconMap: Record<string, React.ReactNode> = {
  InfoTRAC: <IconInfoTrac />,
  InfoPublisher: <IconInfoPublisher />,
};

function Card({
  id, logo, name, description,
}: CardProps): React.ReactNode {
  const navigate = useNavigate();

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.logo}>
          {logo ? (
            <img src={logo} alt={name} className={styles.img} />
          ) : (
            iconMap[name] || <IconInfoTrac />
          )}
        </div>
        <h3 className={styles.title}>{name}</h3>
        {description && <span className={styles.description}>{description}</span>}
      </div>
      <div style={{ marginTop: 10 }}>
        <Button
          size="middle"
          type="primary"
          className={styles.btn}
          onClick={() => navigate(`/product/${id}/${encodeURIComponent(name)}`)}
        >
          Get help
        </Button>
      </div>
    </div>
  );
}

export default function Cards(): React.ReactNode {
  // const { data, error, loading } = useProductsGet();
  const { data, loading } = useProductContext();

  // if (loading) return <div>Loading...</div>;
  // if (error || !data) return <div>Failed to load products</div>;

  return (
    <div className={styles.wrapper}>
      {data?.map((product) => (
        <Card
          key={product.id}
          id={product.id}
          name={product.name}
          description={product.description}
          logo={typeof product.logo === 'string' ? product.logo : undefined}
        />
      ))}
    </div>
  );
}
